import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
  setBody: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    // fetch the page if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.emailTemplates, props.id).then((data) => {
        props.reset(data)
        props.setBody(data.body)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [props.currentCustomer])
}

export default useInit
